<form [formGroup]="formGroup" class="adjustment-wrapper">
  <div class="adjustment-form">
    <mat-checkbox formControlName="checked" color="primary">
      <mat-label>
        <div>{{ modeConfig.title }}</div>
        @if (data.note) {
          <div class="note">{{ data.note }}</div>
        }
      </mat-label>
    </mat-checkbox>
  </div>
  @if (formGroup.get('checked').value) {
    <div class="adjustment-entries-wrapper">
      <div class="adjustment-entry">
        <div>{{ modeConfig.balanceLabel }}</div>
        <app-form-field-money class="inline" [fieldConfig]="currentConfig" [editMode]="false" [data]="this.current">
        </app-form-field-money>
      </div>
      <div class="adjustment-entry">
        <div>{{ modeConfig.adjustmentLabel }} {{ operation }}</div>
        <div class="adjustment-input">
          <mat-button-toggle-group appearance="legacy" formControlName="adjustmentType">
            <mat-button-toggle value="CREDIT"><i class="fas fa-plus"></i></mat-button-toggle>
            <mat-button-toggle value="DEBIT"><i class="fas fa-minus"></i></mat-button-toggle>
          </mat-button-toggle-group>
          <app-form-field-money
            class="inline"
            [onlyPositive]="true"
            [fieldConfig]="deltaConfig"
            [editMode]="true"
            [formGroup]="this.formGroup">
          </app-form-field-money>
        </div>
      </div>
      <mat-divider class="adjustment-divider"></mat-divider>
      <div class="adjustment-entry adjustment-summary {{ summaryClass }}">
        <div>
          <i class="{{ summaryIcon }}"></i>
          <span>{{ modeConfig.newCashLabelLabel }}</span>
        </div>
        <app-form-field-money class="inline" [editMode]="false" [data]="postChanges" [fieldConfig]="postChangesConfig">
        </app-form-field-money>
      </div>
    </div>
  }
</form>
